const PERMISSION_KEY= "core:referral_withdrawal";
const PAGE_URL = {
    REFERRAL_WITHDRAWAL_PAGE: "/admin/core/referral-withdrawal"
}

export {PERMISSION_KEY, PAGE_URL}

